import { Flex, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Text } from '@feathr/components';
import { useSupportChat } from '@feathr/extender/hooks';

import * as styles from './MetaHelpFooter.css';

const META_SETUP_GUIDE_URL =
  'https://help.feathr.co/hc/en-us/articles/9172581418263-How-to-Integrate-Meta-with-Feathr';

function MetaHelpFooter(): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const { openSupportChat } = useSupportChat();

  return (
    <Flex align={'center'} gap={theme.spacing['1']} justify={'center'}>
      <Text.DefaultRegular>{t('Need help setting up? ')}</Text.DefaultRegular>
      <Text.DefaultRegular
        className={styles.helpLink}
        href={META_SETUP_GUIDE_URL}
        inline={true}
        target={'_blank'}
      >
        {t('View setup guide')}
      </Text.DefaultRegular>
      <Text.DefaultRegular>{t(' or ')}</Text.DefaultRegular>
      <Button className={styles.helpLink} onClick={openSupportChat} type={'link'}>
        {t('contact support')}
      </Button>
    </Flex>
  );
}

export default MetaHelpFooter;
